import { Button, Divider, Modal, Paper, Typography } from '@material-ui/core';
import BlockIcon from '@mui/icons-material/Block';
import CloseIcon from '@mui/icons-material/Close';
import FilterTiltShiftOutlinedIcon from '@mui/icons-material/FilterTiltShiftOutlined';
import React, { Dispatch, SetStateAction } from 'react';

import { gray3 } from 'utils/color-styles';

const styles = {
  modal: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: 16,
    width: 600,
    display: 'flex',
    flexDirection: 'column',
  },
  divider: {
    margin: '16px 0',
  },
  contentContainer: {
    width: 'fit-content',
    alignSelf: 'center',
    textAlign: 'center',
    paddingTop: 16,
    paddingBottom: 32,
    color: gray3,
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
};

export const RejectionWarningModal = ({
  showModal,
  setShowModal,
  handleRejectVolunteerReward,
}: {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  handleRejectVolunteerReward: () => void;
}) => {
  const handleConfirmation = () => {
    handleRejectVolunteerReward();
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      style={styles.modal}
      disableAutoFocus
    >
      <Paper style={styles.paper}>
        <div style={styles.modalHeader}>
          <Typography variant="h6" style={{ textAlign: 'center', width: '100%' }}>
            Do you want to reject these rewards?
          </Typography>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={() => setShowModal(false)} />
        </div>
        <Divider style={styles.divider} />
        <Typography component="p" style={styles.contentContainer}>
          Rejected Volunteer Grants will not get any matching donation. The user will be notified
          about the rejection of their application.
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'stretch' }}>
          <Button
            style={{ marginRight: 16, display: 'flex', flex: 'auto' }}
            onClick={() => setShowModal(false)}
          >
            No, don`t reject
            <FilterTiltShiftOutlinedIcon style={{ marginLeft: 5 }} />
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleConfirmation}
            style={{ display: 'flex', flex: 'auto' }}
          >
            Yes, reject Volunteer Grants
            <BlockIcon style={{ marginLeft: 5 }} />
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};
